export const RULE_DEFAULT = {
     fieldId: '',
     fieldValue: '',
     condition: '',
};

export const CONDITION_DEFAULT = {
     key: 'course',
     value: '',
     conjunction: '',
     fieldId: '',
     fieldValue: '',
};

export const INSTRUCTOR_DEFAULT = [
     {
          id: 'newRow0',
          instructorId: '',
          order: 1,
          status: 'enable',
          isLeader: false,
     },
];

export const ORG_MEMBER_DEFAULT = {
     id: '',
     email: '',
     firstName: '',
     lastName: '',
     numberOfSeatUsed: 0,
     orgUserId: '',
     role: 'subscriber',
     orgRole: 'user',
     trainingGroupIds: [],
     token: '',
};

export const ORDER_COUNTRY_DEFAULT = [
     { value: 'US', label: 'United States' },
     { value: 'CA', label: 'Canada' },
     { value: 'AU', label: 'Australia' },
     { value: 'GB', label: 'United Kingdom' },
];

export const DEFAULT_FN = (f) => f;

export const PERCENT_ALLOWED_COMPLETE_LESSON = 90;

export const PRODUCT_MEDIA_DEFAULT_TYPE = 'document';

export const ATTACHMENT_DEFAULT_TYPE = 'document';

export const ENCODING_CHARACTER = '••••••••••••';
export const ENCODING_PRIVATE_CHARACTER = '••••••••••••••••••';
